import type { EventData } from '~/lib/types/Event'

export class EventBuffer {
  private buffer: EventData[] = []
  private flushTimer: NodeJS.Timeout | null = null

  constructor(
    private readonly maxSize: number,
    private readonly flushIntervalMs: number,
    private readonly onFlush: (events: EventData[]) => Promise<void>,
  ) {}

  add(event: EventData): void {
    this.buffer.push(event)

    if (this.buffer.length >= this.maxSize) {
      this.flush()
    } else if (this.flushTimer === null) {
      this.scheduleFlush()
    }
  }

  async flush(): Promise<void> {
    if (this.buffer.length === 0) return

    const eventsToFlush = [...this.buffer]
    this.buffer = []
    this.clearFlushTimer()

    try {
      await this.onFlush(eventsToFlush)
    } catch (error) {
      this.buffer.unshift(...eventsToFlush)
      throw error
    }
  }

  clear(): void {
    this.buffer = []
    this.clearFlushTimer()
  }

  size(): number {
    return this.buffer.length
  }

  private scheduleFlush(): void {
    this.flushTimer = setTimeout(() => {
      this.flush().catch(() => {
        // エラーはonFlush内で処理される
      })
    }, this.flushIntervalMs)
  }

  private clearFlushTimer(): void {
    if (this.flushTimer) {
      clearTimeout(this.flushTimer)
      this.flushTimer = null
    }
  }
}
